import { render } from "./Password.vue?vue&type=template&id=74abaf1e"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__